// src/lib/apiAgreements.js
import { api } from "./api";

export async function getActiveAgreement(code) {
  return api.getJson(`/agreements/active/?code=${encodeURIComponent(code)}`);
}

export async function getAgreementStatus(codes) {
  const qs = codes.map(encodeURIComponent).join(",");
  return api.getJson(`/agreements/status/?codes=${qs}`); // { results: [...] }
}

export async function acceptAgreement(agreementType, context = {}) {
  return api.postJson(`/agreements/accept/`, {
    agreement_type: agreementType,
    context,
  });
}
